import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import TopMenuReducer from '../features/TopMenu/reducer/top_menu_view_reducer';
import SideMenuReducer from '../features/SideMenu/reducer/side_menu_view_reducer';
//import tokenManagerReducer from '../features/tokenManager/reducer/tokenManagerReducer';
import user_table from '../features/UserTableThingy/reducer/table_reducer';
import StatusMonitor from '../features/StatusMonitorThingy/reducer/table_reducer';
import mandanten_table from '../features/MandantenTableThingy/reducer/table_reducer';
import mandanten_input from '../features/MandantenInputThingy/reducer/Reducer';
import LoginReducer from '../features/Login/reducer/loginReducer';
import LogTableReduder from '../features/LogTableThingy/reducer/table_reducer';
import VulnerabilitySummaryTableReducer from '../features/VulnerabilitySummaryTableThingy/reducer/table_reducer';
import VulnerabilitySummaryGraphReducer from '../features/VulnerabilitySummaryGraphThingy/reducer/reducer';
import tripleTableInfos from '../features/TripleBOxDashboardThingy/reducer/table_reducer';
import userdetails from '../features/UserDetailsCombo/reducer/reducer';
import CredComboReducer from '../features/CredentialsTableThingy/reducer/table_reducer';
import footerthing from  '../features/Footer/reducer/reducer';
import BreadCrump from '../features/BreadCrumpNav/reducer/table_reducer';
import Language from '../features/A_ProviderContainer/reducer/reducer';
import LicenseDetails from '../features/LicenseDetailsCombo/reducer/reducer';
import LicenseInput from '../features/LicenseCreateInput/reducer/Reducer';
import TargetTable from '../features/LicenseTableThingy/reducer/table_reducer';
import UpdateData from '../features/UpdateContainer/reducer/table_reducer';
import ScriptData from '../features/ScriptContainer/reducer/table_reducer';
import UserInput from '../features/UserInputThingy/reducer/Reducer';
import NewsList from '../features/NewsManagerTableThingy/reducer/table_reducer';
import AuthSettings from '../features/AuthSettingsThingy/reducer/Reducer';
// import NewsEditor from '../features/NewsInputThingy/reducer/Reducer';
// import loginReducer from '../features/Login/reducer/loginReducer';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    topMenu: TopMenuReducer,
    language:Language,
    sideMenu: SideMenuReducer,
    tableUser: user_table,
    StatusMonitor:StatusMonitor,
    tableMandant: mandanten_table,
    UpdateData:UpdateData,
    ScriptData:ScriptData,
    tripleTableInfo : tripleTableInfos,
    LoginManager: LoginReducer,
    LogTableThingy:LogTableReduder,
    TargetTable:TargetTable,
    LicenseDetails:LicenseDetails,
    LicenseInput:LicenseInput,
    MandantenInput:mandanten_input,
    vuln_summary_table:VulnerabilitySummaryTableReducer,
    vuln_summary_graph:VulnerabilitySummaryGraphReducer,
    UserDetails:userdetails,
    UserInput:UserInput,
    CredComboReducer:CredComboReducer,
    footer:footerthing,
    breadCrump:BreadCrump,
    newslist:NewsList,
    AuthSettings:AuthSettings,
   // newsEditor:NewsEditor,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
